import React, { useState } from 'react';
import { 
  Box, 
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { PlayCircleOutline, Close } from '@mui/icons-material';
import copite from '../../assets/images/bicycle_game/ecran2_copite.png'
import mereuimpreuna0 from '../../assets/images/bicycle_game/0-mereu-impreuna.png';
import mereuimpreuna1 from '../../assets/images/bicycle_game/1-mereu-impreuna.png';
import mereuimpreuna2 from '../../assets/images/bicycle_game/2-mereu-impreuna.png';
import mereuimpreuna3 from '../../assets/images/bicycle_game/3-mereu-impreuna.png';
import mereuimpreuna4 from '../../assets/images/bicycle_game/4-mereu-impreuna.png';
import mereuimpreuna6 from '../../assets/images/bicycle_game/6-mereu-impreuna.png';
import mereuimpreuna7 from '../../assets/images/bicycle_game/7-mereu-impreuna.png';
import mereuimpreuna9 from '../../assets/images/bicycle_game/9-mereu-impreuna.png';
import mereuimpreuna10 from '../../assets/images/bicycle_game/10-mereu-impreuna.png';
import street from '../../assets/videos/Street-15s.webm';

// Define the MediaItem interface
interface MediaItem {
  type: 'image' | 'video';
  src: string;
  alt: string;
  thumbnail?: string;
}

// Define gallery images
const galleryItems: MediaItem[] = [
  // First row - 5 images
  { 
    type: 'image', 
    src: mereuimpreuna0, 
    alt: 'Persoane ciocnind halbe de bere' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna1, 
    alt: 'Persoană cu bere' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna2,
    alt: 'Bere Kozel' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna3, 
    alt: 'Persoane la bar' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna4, 
    alt: 'Grup la bar' 
  },
  
  { 
    type: 'image', 
    src: mereuimpreuna6, 
    alt: 'Grup pe scări' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna7, 
    alt: 'Grup la masă' 
  },
  { 
    type: 'image', 
    src: mereuimpreuna9, 
    alt: 'Grup de prieteni' 
  },
];

// Center video
const mainVideo: MediaItem = {
  type: 'video',
  src: street, 
  thumbnail: mereuimpreuna10,
  alt: 'Video prezentare comunitate Kozel'
};

const GallerySection: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [currentMedia, setCurrentMedia] = useState<MediaItem | null>(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleOpen = (media: MediaItem): void => {
    setCurrentMedia(media);
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <Box sx={{ 
      width: '100%',
      backgroundColor: '#4a3824',
      padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
      boxSizing: 'border-box',
      overflow: 'hidden',
      maxWidth: '100vw'
    }}>
      {/* Section Title with hooves images */}
        <Box sx={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: { xs: 3, sm: 4, md: 5 },
        position: 'relative',
        width: '100%'
        }}>
        {/* Left hooves image */}
        <Box
            component="img"
            src={copite}
            alt="Kozel copite"
            sx={{ 
            height: { xs: '0', sm: '20px', md: '25px' },
            width: 'auto',
            marginRight: { sm: 1, md: 2 },
            transform: 'scaleX(-1)', 
            display: { xs: 'none', sm: 'block' }
            }}
        />
        
        {/* Title */}
        <Typography 
            variant="h4" 
            sx={{ 
            color: '#e9d4a8',
            textAlign: 'center',
            fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2rem' },
            padding: '0 0.5rem',
            fontFamily: theme.fonts.poplar
            }}
        >
            PRIETENII COMUNITĂȚII KOZEL CARE NE SUSȚIN CU ENERGIE!
        </Typography>
        
        {/* Right hooves image */}
        <Box
            component="img"
            src={copite}
            alt="Kozel copite"
            sx={{ 
            height: { xs: '0', sm: '20px', md: '25px' },
            width: 'auto',
            marginLeft: { sm: 1, md: 2 },
            display: { xs: 'none', sm: 'block' } 
            }}
        />
        </Box>

      {/* Center Video */}
      <Box 
        sx={{
          position: 'relative',
          width: { xs: '60%', sm: '50%', md: '40%' },  
          height: { xs: '300px', sm: '400px', md: '500px' },
          margin: '0 auto 2rem auto',
          cursor: 'pointer',
          borderRadius: '8px',
          overflow: 'hidden',
          backgroundColor: '#333'
        }}
        onClick={() => handleOpen(mainVideo)}
      >
        <Box
          component="img"
          src={mainVideo.thumbnail}
          alt={mainVideo.alt}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            borderRadius: '8px',
          }}
        />
        <IconButton
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(233, 212, 168, 0.7)',
            '&:hover': {
              backgroundColor: 'rgba(233, 212, 168, 0.9)',
            },
            width: { xs: '50px', sm: '60px', md: '80px' },
            height: { xs: '50px', sm: '60px', md: '80px' },
          }}
        >
          <PlayCircleOutline 
            sx={{ 
              fontSize: { xs: '30px', sm: '40px', md: '60px' },
              color: '#4a3824'
            }} 
          />
        </IconButton>
      </Box>

      {/* First Row of Images */}
      <Grid 
        container 
        spacing={{ xs: 1, sm: 2, md: 2 }}
        sx={{ mb: 2 }}
      >
        {galleryItems.slice(0, 4).map((item, index) => (
          <Grid item xs={6} sm={3} key={`row1-${index}`}>
            <Box
              onClick={() => handleOpen(item)}
              sx={{
                width: '100%',
                paddingTop: '100%',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '4px',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'scale(1.03)',
                }
              }}
            >
              <Box
                component="img"
                src={item.src}
                alt={item.alt}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Second Row of Images */}
      <Grid 
        container 
        spacing={{ xs: 1, sm: 2, md: 2 }}
      >
        {galleryItems.slice(4, 8).map((item, index) => (
          <Grid item xs={6} sm={3} key={`row2-${index}`}>
            <Box
              onClick={() => handleOpen(item)}
              sx={{
                width: '100%',
                paddingTop: '100%',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '4px',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'scale(1.03)',
                }
              }}
            >
              <Box
                component="img"
                src={item.src}
                alt={item.alt}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Media Preview Dialog */}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        PaperProps={{
          sx: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden'
          }
        }}
      >
        <DialogContent 
          sx={{ 
            padding: 0,
            backgroundColor: 'transparent',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: { xs: '10px', md: '20px' },
              right: { xs: '10px', md: '20px' },
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: 'white',
              zIndex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)',
              }
            }}
          >
            <Close />
          </IconButton>
          
          {currentMedia && currentMedia.type === 'video' ? (
            <Box
              component="video"
              src={currentMedia.src}
              controls
              autoPlay
              sx={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                borderRadius: '4px'
              }}
            />
          ) : (
            <Box
              component="img"
              src={currentMedia?.src}
              alt={currentMedia?.alt || "Gallery image"}
              sx={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                borderRadius: '4px'
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default GallerySection;